import { createPageableParams } from "@/modules/core/services/table-utils";
import WrapperService from "@/modules/core/services/wrapper-service";


const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facility"

const sortTableFields = ["buildingName", "buildingCity", "buildingStreet", "typeName"];
const sortDatabaseFields = ["building.name", "building.address.city", "building.address.street", "type.name"];

const serviceName = "Facility-Service: ";

export default class FacilityService {

  static async createSingleQRCode(facilityId, name, successF, errorF){
    let formData = new FormData();
    formData.append("facilityId", facilityId)
    formData.append("name", name);

    await WrapperService.post(API_URL + '/createqrcode', formData, serviceName, successF, errorF);
  }

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readByIdFromAPI(facilityId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + facilityId, null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,sortTableFields,sortDatabaseFields)
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async readAllAssignedPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/assigned/page', { params: params }, serviceName, successF, errorF);
  }

  static async readFromAPI(facilityID, successF, errorF) {
    await WrapperService.get(API_URL + '/' + facilityID, null, serviceName, successF, errorF);
  }

  static postToAPI(facility, successF, errorF) {
    WrapperService.post(API_URL, facility, serviceName, successF, errorF);
  }

  static putToAPI(facility, successF, errorF) {
    WrapperService.put(API_URL + '/' + facility.id, facility, serviceName, successF, errorF);
  }

  static deleteFromAPI(facility, softDelete, successF, errorF) {
    if (softDelete) {
      WrapperService.delete(API_URL + '/' + facility.id + '/true', serviceName, successF, errorF);
    } else {
      WrapperService.delete(API_URL + '/' + facility.id + '/false', serviceName, successF, errorF);
    }
  }

  static restoreFromApi(facility, successF, errorF) {
    WrapperService.put(API_URL + '/restore/' + facility.id, null, serviceName, successF, errorF);
  }

  static async readDisplays(successF, errorF) {
    await WrapperService.get(API_URL + '/displays', null, serviceName, successF, errorF)
  }

  static copyFacility(facility, successF, errorF) {
    return WrapperService.post(API_URL + '/copy', facility, serviceName, successF, errorF);
  }

  static async readFromAPIByDisplayId(displayId, successF, errorF) {
    await WrapperService.get(API_URL + '/display/' + displayId, null, serviceName, successF, errorF);
  }

  static async readForWorker(facilityId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + facilityId + '/worker', null, serviceName, successF, errorF);
  }

  static async loadFacilityList(customerId, successF, errorF){
    await WrapperService.get(API_URL + '/load-issue-facility/' + customerId, null, serviceName, successF, errorF);
  }

  static async readForGbuExportByCustomer(customerId, successF, errorF) {
    await WrapperService.get(API_URL + '/gbu-export/' + customerId , null, serviceName, successF, errorF);
  }
  static async readForGbuExport(successF, errorF) {
    await WrapperService.get(API_URL + '/gbu-export', null, serviceName, successF, errorF);
  }

  static async updateActualCosts(facilityId, costs, successF, errorF){
    await WrapperService.put(API_URL + '/cost-analysis/' + facilityId, costs, serviceName, successF, errorF);
  }
}
